import { render, staticRenderFns } from "./SocialRegister.vue?vue&type=template&id=6aa38f32&scoped=true&"
import script from "./SocialRegister.vue?vue&type=script&lang=js&"
export * from "./SocialRegister.vue?vue&type=script&lang=js&"
import style0 from "./SocialRegister.vue?vue&type=style&index=0&id=6aa38f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa38f32",
  null
  
)

export default component.exports